import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Icon from '../../design-system/General/Icon';
import 'swiper/css';
import { useRef, useState } from "react";
import styles from './Portfolio.module.css';

export default function PortfolioSection({title, text, portfolios, sectionRef}) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animateTitle, setAnimateTitle] = useState(false);
    const [animateImage, setAnimateImage] = useState(false);


    function handleSlideChange(swiper) {
      setCurrentIndex(swiper.realIndex + 1);

      setAnimateImage(false);
      setTimeout(() => setAnimateImage(true), 10);

      setAnimateTitle(false);
      setTimeout(() => setAnimateTitle(true), 10);
    }

    return (
      <section className={styles['portfolio-section']} ref={sectionRef}>
        <div className="container-lg">
          <div className="row position-relative align-items-center">
                <div className={classnames(styles['portfolio-section_head'], 'col-12 col-lg-2')}>
                  <h2  className={styles['portfolio-section_title']}>{title}</h2>
                  <p className={styles['portfolio-section_text']}>{text}</p>
                </div>

                <div className='col-12 col-sm-11 col-lg-9 position-relative'>
                  <Swiper
                    modules={[Navigation]}
                    slidesPerView={1}
                    loop={true}
                    speed={0} 
                    allowTouchMove={true}
                    onSlideChange={handleSlideChange}
                    className={styles['portfolio-swiper']}
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                    }}
                  >
                    {portfolios.length > 0 && portfolios.map( p => (
                      <SwiperSlide>
                        <div className={classnames(styles['portfolio-card'], 'position-relative', 'd-flex')}>
                            {p.pro_image && 
                              <figure className={classnames(styles['portfolio-card_thumb'], animateImage && styles['img-animate'])}>
                                <a className='ratio ratio-16x9' href={p.pro_link}><img src={p.pro_image.url} alt={p.pro_title} width={p.pro_image.width} height={p.pro_image.height} /></a>
                              </figure>
                            }
                            <div className={styles['portfolio-card_content']}>
                              <h3 className={classnames(styles['portfolio-card_title'], animateTitle && styles['title-animate'])}>
                                <a href={p.pro_link}>{p.pro_title}</a>
                              </h3>
                            </div>
                        </div>
                    </SwiperSlide>))}
                  </Swiper>

                  <div className={styles['custom-navigation-wrapper']}>
                    <div className={styles['custom-navigation']}>
                      <button ref={prevRef} className={styles['prev-btn']}>
                        <Icon name="icon-arrow-left" />
                      </button>
                      <button ref={nextRef} className={styles['next-btn']}>
                        <Icon name="icon-arrow-left" />
                      </button>
                    </div>

                    <div className={styles['portfolio-count']}>
                      <div className={styles['portfolio-count_current']}>0{currentIndex}</div>
                      <div className={styles['portfolio-count_total']}>0{portfolios.length}</div>
                    </div>
                  </div>
                </div>
                
          </div>
        </div>
      </section>
    );
}